import { Modal } from "antd";
import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { callApi } from "../../utils/api";
import { getFileStatus, getVettingFileStatus } from '../../utils/fileStatus';
import VerifyFileModal from "./VerifyFileModal";
import { isEmpty } from 'lodash';
import app from "../../App";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore
} from "react-toasts";
import moment from 'moment';
import Select from 'react-select';
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";
interface AllProps {
  match: any;
  history: any;
}
declare var $: any;

export default class SearchResults extends Component<AllProps> {
  state = {
    filesbank: "",
    selectVal: false,
    setResponse: true,
    files: [],
    isFileRefresh: false,
    fileToBeVerified: 0,
    currentFileid: '',
    status: "",
    data: '',
    OutTime: 0,
    inTime: 0,
    inreason: "",
    outreason: "",
    autoAssign: [
      {
        "id": "1",
        "module_name": "Auto Assign",
        "status": true
      }
    ],
    isLoading: false,
    reassign_type: "",
    selectedFileId: "",
    holdVal: false,
    holdreason: "",
    unholdVal: false,
    unholdreason: "",
    showValid: false,
    reassignValidMessage: "",
    pageDynamic: [],
    deviationReason: "",
    deviationRequestFile: {},
    usersList: [],
    deviationRequestByList: [],
    deviationReasonList: [],
    doubtLocationList: [],
    designationList: [],
    deviationTakeDetails: {
      deviationRequestBy: '',
      deviationUser: '',
      deviationRequestReason: [],
      doubtLocation: [],
      designation: '',
      mobileNo: '',
      deviationRequired: false,
      showOtherFields: {
        deviationRequestBy: false,
        deviationUser: false,
        designation: false,
        deviationRequestReason: false,
        doubtLocation: false,
      },
    },
    isDeviationTakeLoading: false,
    isSearching: false,
  };
  appRef: app | null = null;
  isComponentMounted: any = true;;
  abortController = new AbortController();

  componentWillUnmount() {
    // Cancel any pending API calls if you're using AbortController
    // or just set a flag to prevent state updates
    this.isComponentMounted = false;
    this.abortController.abort(); // Cancel any pending requests
  }

  async componentDidMount() {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
    document.querySelectorAll(".modal-backdrop, .ant-modal-mask, .ant-modal-wrap").forEach((el) => el.remove());
    this.isComponentMounted = true;
    this.getFiles();
    this.getOutTime();
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.ouTime();
    }
    this.getAutoAssignStatus();
    this.getPageDynamicData();
    this.getDeviationDropdownLists();
    this.getUsers();
    this.getDesignation();
  }

  UNSAFE_componentWillReceiveProps(nextProps: AllProps) {
    // Get current and next values
    const currentSearchName = this.props.match.params.name;
    const nextSearchName = nextProps.match.params.name;

    // Decode both current and next search values
    const currentSearchValue = this.props.match.params.searchValue
      ? decodeURIComponent(this.props.match.params.searchValue)
      : '';
    const nextSearchValue = nextProps.match.params.searchValue
      ? decodeURIComponent(nextProps.match.params.searchValue)
      : '';

    // Check if search parameters actually changed
    // if (currentSearchValue !== nextSearchValue || currentSearchName !== nextSearchName) {

    // Pass the nextProps to getFiles
    this.getFiles(nextProps);
    // }
  }

  getAutoAssignStatus = () => {
    callApi("GET", "module_option_select.php", "")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ autoAssign: result.responseJson.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  GotoWorkFile = (id, process_office_id) => {
    console.log("process_office_id", process_office_id);
    let process_officer_id = JSON.stringify(process_office_id);
    localStorage.setItem("process_office_id", process_officer_id);
    const userid1: any = localStorage.getItem("user1");
    const url = `/search-results/file_name/${id}`;
    localStorage.setItem("url", url);
    let obj = { file_id: id };
    localStorage.setItem("thisPopup", JSON.stringify(obj));
    localStorage.setItem("currentfileId", JSON.stringify(id));
    const take_file: any = localStorage.getItem("takenfile_id");
    const user: any = localStorage.getItem("user");
    // const taken_file = user ? JSON.parse(user)["taken_file"] : take_file;
    const getfileId: any = localStorage.getItem("currentfileId");
    if (process_officer_id == userid1 && take_file != "" && take_file == getfileId) {
      this.timeUpdate(id, "workfile");
    }
    this.props.history.push("/work-file/7/" + id);
  };

  setFileId = (id: any) => {
    this.setState({ selectedFileId: id, reassignValidMessage: '', showValid: false, reassign_type: '' });
  }

  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ pageDynamic: result.responseJson.data, });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  previousPop = () => {
    $("#out_reason").modal("show");
    $("#another-reason").modal("hide");
  }

  disableReassignModalHandler = () => {
    $("#re-assign").modal("hide");
  }

  fileReassign = () => {
    const userid1: any = localStorage.getItem("user1");
    const { selectedFileId, reassign_type, files } = this.state;
    if (reassign_type == "") {
      this.setState({ selectVal: true });
    } else {
      if (files.length > 0) {
        // Iterate through the files array
        files.forEach((file: any) => {
          let fileStatus: any = file.file_status;
          let assigned_to: any = file.assigned_to;
          let verified_by: any = file.verified_by;
          if (assigned_to == '') {
            this.setState({ reassignValidMessage: "This file is already in queue", showValid: true });
            return;
          } else if (fileStatus == "0") {
            this.setState({ reassignValidMessage: "This file is already in queue", showValid: true });
            return;
          } else if (fileStatus == "5") {
            this.setState({ reassignValidMessage: "Completed file can't be reassigned", showValid: true });
            return;
          } else if (fileStatus == "7") {
            this.setState({ reassignValidMessage: "This file is still not query received. So can't be reassigned", showValid: true });
            return;
          } else if (fileStatus == "3") {
            this.setState({ reassignValidMessage: "This file is Hold. So can't be reassigned", showValid: true });
            return;
          } else if (fileStatus == "2" && assigned_to == '') {
            this.setState({ reassignValidMessage: "This file is already in Queue. So can't be reassigned", showValid: true });
            return;
          } else if (fileStatus == "6" && verified_by == '') {
            this.setState({ reassignValidMessage: "This file is in verification queue. So can't be reassigned for Process", showValid: true });
            return;
          } else if ((fileStatus == "6" || fileStatus == '14') && reassign_type == 'process') {
            this.setState({ reassignValidMessage: "This file is can't be reassigned for Process", showValid: true });
            return;
          } else if (fileStatus != "6" && fileStatus != "14" && reassign_type == "verification") {
            this.setState({ reassignValidMessage: "This file is Process. So can't be reassigned for Verification", showValid: true });
            return;
          } else {
            this.setState({ isLoading: true, showValid: false });
            let obj = {
              "file_no": selectedFileId,
              "reassign_type": reassign_type,
              "user_id": JSON.parse(userid1)
            }
            callApi("POST", "reassign.php", obj)
              .then(res => res.data)
              .then(response => {
                if (response.status == 200) {
                  this.setState({ isLoading: false, reassign_type: "", selectedFileId: "" });
                  $("#re-assign").modal("hide");
                  this.getFiles();
                  this.reassignupdatetime();
                  ToastsStore.success(response.message);
                }
              }).catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
              })
          }
          console.log("state", this.state);
        });
      }
    }
  }
  holdFile = () => {
    this.setState({ holdVal: true });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const { holdreason, holdVal } = this.state;
    if (holdreason != "" && holdVal) {
      this.setState({ isLoading: true });
      const obj = {
        file_id: this.state.selectedFileId,
        hold_by: userId,
        reason: holdreason
      }
      callApi("POST", "hold_file.php", obj)
        .then(res => res.data)
        .then(response => {
          if (response.statuscode == 200) {
            this.setState({ holdVal: false, holdreason: '', isLoading: false });
            ToastsStore.success(response.message);
            $("#holdModal").modal("hide");
            this.getFiles();
            this.timeUpdate(this.state.selectedFileId, 'hold');
          } else {
            ToastsStore.error(response.message);
          }
        }).catch(err => {
          console.log(err);
          this.setState({ files: [] });
        });
    }
  }
  unholdFile = () => {
    this.setState({ unholdVal: true });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const { unholdreason, unholdVal } = this.state;
    if (unholdreason != "" && unholdVal) {
      this.setState({ isLoading: true });
      const obj = {
        file_id: this.state.selectedFileId,
        unhold_by: userId,
        reason: unholdreason
      }
      callApi("POST", "unhold_file.php", obj)
        .then(res => res.data)
        .then(response => {
          if (response.statuscode == 200) {
            this.setState({ unholdVal: false, unholdreason: '', isLoading: false });
            ToastsStore.success(response.message);
            this.getFiles();
            $("#unholdModal").modal("hide");
            this.timeUpdate(this.state.selectedFileId, 'unhold');
          } else {
            ToastsStore.error(response.message);
          }
        }).catch(err => {
          console.log(err);
          this.setState({ files: [] });
        });
    }
  }


  BacktoFile = () => {
    $("#out_reason").modal("hide");
    const fileid1: any = localStorage.getItem("currentfileId");
    if (localStorage.getItem("filedashboardback") == "true") {
      this.props.history.push("/search-results/file_name/" + JSON.parse(fileid1));
      localStorage.removeItem("filedashboardback")
    }
    else {
      this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));

    }
  }
  getOutTime = () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime))
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
    else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }

  }
  ouTime = () => {
    const getfileId: any = localStorage.getItem("currentfileId");
    console.log("54", JSON.parse(getfileId))
    console.log("32", getfileId);
    if (localStorage.getItem("currentfileId")) {
      $("#out_reason").modal("show");
    }
  }

  outimeGet = () => {
    this.setState({ isLoading: true });
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    console.log("70", intime);
    const outtime: any = localStorage.getItem("outtimeGet");
    console.log("73", outtime);
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
    console.log('Second Spn', secondsSpent);
    let updatedRemainingTime: any = localStorage.getItem('updatedRemainingTime');
    let updatedtime = Math.round(updatedRemainingTime);
    const status: any = localStorage.getItem("dashboard_status");
    const insertId: any = localStorage.getItem("ProcessEodInsertID");

    if (this.state.outreason == "") {
      this.setState({ selectVal: true });
    }
    else {
      let obj = {
        "file_id": JSON.parse(fileid1),
        "user_id": JSON.parse(userid1),
        "in_reason": JSON.parse(inreason),
        "out_reason": this.state.outreason,
        "intime": JSON.parse(intime),
        "outtime": JSON.parse(outtime),
        "insert_date": JSON.parse(outdate),
        "total_seconds": secondsSpent,
        "balance_min": updatedtime,
        "dashboard_status": status,
        "insert_id": insertId
      }

      // console.log("72",obj);
      callApi("POST", "process_eod_insert.php", obj)
        .then(res => res.data)
        .then(response => {
          this.setState({ isLoading: false });
          localStorage.removeItem('updatedRemainingTime');
          console.log("76", response);
          localStorage.removeItem("in_reason");
          localStorage.removeItem("outreason");
          localStorage.removeItem("IntimeGet");
          localStorage.removeItem("OutDateGet");
          $("#out_reason").modal("hide");
          $("#another-reason").modal("hide");
          ToastsStore.success("Your Reason Saved Successfully");
          let process_officerId: any = localStorage.getItem("process_office_id");
          let process_officer_id = JSON.parse(process_officerId);
          const userid1: any = localStorage.getItem("user1");
          let user_id = JSON.parse(userid1);
          let file_id = JSON.parse(fileid1);
          const take_file: any = localStorage.getItem("takenfile_id");
          const user: any = localStorage.getItem("user");
          // const taken_file = user ? JSON.parse(user)["taken_file"] : take_file;
          const getfileId: any = localStorage.getItem("currentfileId");
          if (process_officer_id == user_id && take_file != "" && take_file == getfileId) {
            console.log(`${process_officer_id}---${user_id}`);

            this.timeUpdate(file_id, "fileout");
          } else {
            localStorage.removeItem('currentfileId');
          }
          if (this.appRef) {
            this.appRef.intervalClear();
            localStorage.removeItem('updatedRemainingTime');
            console.log("file out");
          }
        }).catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
          ToastsStore.error("Your Reason Not Stored");
        })
    }
  }

  timeUpdate = (fileid, type) => {
    console.log(`${fileid}---${type}`);

    const loginuser: any = localStorage.getItem("user1");
    let req;
    this.state.autoAssign.find(
      (data: any) => {
        if (data.module_name === "Auto Assign" && data.status == true) {
          if (type == "workfile") {
            req = {
              work_in_progress_by: JSON.parse(loginuser),
              id: fileid,
              taken_status: 1,
              reason: "Work Inprogress",
              created_by: JSON.parse(loginuser),
              color: "#aceaaf"
            }
          } else if (type == "filedash") {
            req = {
              work_in_progress_by: JSON.parse(loginuser),
              id: fileid,
              reason: "Work Inprogress",
              taken_status: 1,
              created_by: JSON.parse(loginuser),
              color: "#aceaaf"
            }
          } else if (type == 'hold') {
            req = {
              id: fileid,
              verification_hold_by: JSON.parse(loginuser),
              reason: "Hold",
              created_by: JSON.parse(loginuser),
              color: "gray"
            };
          } else if (type == 'unhold') {
            req = {
              id: fileid,
              verification_unhold_by: JSON.parse(loginuser),
              reason: "Unhold",
              created_by: JSON.parse(loginuser),
              color: "gray"
            };
          }
          else {
            req = {
              id: fileid,
              reason: "File Out",
              created_by: JSON.parse(loginuser)
            }
            localStorage.removeItem("currentfileId");
            // localStorage.removeItem("takenfile_id");
          }
        }
      })
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {

      });
  }

  onchangeReason = (e: any) => {

    if (e.target.value == "Other") {
      this.setState({ in_reason: "", selectVal: false })
      $("#out_reason").modal("hide");
      $("#another-reason").modal("show");
    }
    else if (e.target.value == "select") {
      this.setState({ setResponse: false })
    }
    else {
      // this.setState({})
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };
  onchange = (e: any) => {
    this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
  };

  getFiles = (props = this.props) => {
    // if (this.state.isSearching) return;

    // this.abortController.abort();
    // this.abortController = new AbortController();

    // Use the passed props or default to this.props
    const decodedSearchValue = decodeURIComponent(props.match.params.searchValue);
    const searchName = props.match.params.name;

    // console.log('Searching for:', decodedSearchValue); // Debug log
    // console.log('Search type:', searchName); // Debug log

    this.setState({
      files: [],
      isFileRefresh: false,
      filesbank: "",
      isSearching: true
    }, () => {
      callApi("POST", "search.php", {
        [searchName]: decodedSearchValue.trim(),
        "vetting_file_name": decodedSearchValue.trim(),
        "search_type": searchName
      })
        .then(res => res.data)
        .then(response => {
          if (!this.isComponentMounted) return;

          const files = response.data || [];
          this.setState({ filesbank: files });

          if (files && files.length > 0) {
            const processedFiles = files.map((file, index) => {
              const processedFile = { ...file };
              Object.keys(processedFile).forEach(fileKey => {
                processedFile[fileKey] = !processedFile[fileKey] ? "" :
                  typeof processedFile[fileKey] !== 'string' ? String(processedFile[fileKey]) : processedFile[fileKey];
              });
              processedFile.index = index + 1;
              return processedFile;
            });
            this.setState({ files: processedFiles, isFileRefresh: true, isSearching: false });
          } else {
            this.setState({ files: [], isFileRefresh: true, isSearching: false });
          }
        })
        .catch(err => {
          console.log(err);
          if (this.isComponentMounted) {
            this.setState({ files: [], isFileRefresh: true, isSearching: false });
          }
        });
    });
  };

  editVettingDetails = (file) => {
    const searchValue = encodeURIComponent(this.props.match.params.searchValue);
    localStorage.setItem("vetting_search_edit", JSON.stringify(true));
    localStorage.setItem("vetting_search_return_url", `/vetting-results/vetting/${searchValue}`);
    this.props.history.push(`/vetting-add/${file.id}`);
  };

  goToFileDashboard = (id, process_office_id) => {
    let process_officer_id = JSON.stringify(process_office_id);
    localStorage.setItem("process_office_id", process_officer_id);
    const userid1: any = localStorage.getItem("user1");
    const url = this.props.match.params.name != "vetting" ? `/search-results/file_name/${id}` : `/search-results/vetting/${id}`;
    localStorage.setItem("url", url);
    let obj = { "id": id }
    localStorage.setItem("thisPopup", JSON.stringify(obj))
    localStorage.setItem("currentfileId", JSON.stringify(id));

    if (this.props.match.params.name != "vetting") {
      const fileBank: any = this.state.filesbank;
      fileBank.forEach(element => {
        if (element.id == id) {
          localStorage.setItem("bankName", element.bank_name);
        }
      });

      const take_file: any = localStorage.getItem("takenfile_id");
      const user: any = localStorage.getItem("user");
      // const taken_file = user ? JSON.parse(user)["taken_file"] : take_file;
      const getfileId: any = localStorage.getItem("currentfileId");
      if (process_officer_id == userid1 && take_file != "" && take_file == getfileId) {
        this.timeUpdate(id, "filedash");
      }
      this.props.history.push("/file-dashboard/" + id);
    } else {
      this.props.history.push("/vetting-overview/" + id);
    }
  };
  assignFile = (modal: any) => {
    this.setState({ fileToBeVerified: modal.id });
  };
  getBillVettingComplete(file) {
    this.setState({ currentFileid: file.id });
    const obj = {
      id: file.id
    }
    callApi("POST", "bill_get_vetting_complete.php", obj)
      .then((res) => res.data)
      .then((result) => {
        const data = result.data
        if (data && data.length > 0) {
          this.setState({ status: data[0].vetting_status === "1" });
        }

        if (result.data) {
        } else {
        }
      });
  }
  updateBillVettingComplete(status) {
    callApi("POST", "bill_vetting_complete.php", {
      file_id: this.state.currentFileid,
      status,
    })
      .then((res) => res.data)
      .then((result) => {
        if (result.data) {
          this.vettingcompleteupdatetime();
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  vettingcompleteupdatetime() {
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      vetting_completed_time: currenttime,
      vetting_completed_date: currentdate,
      vetting_completed_by: JSON.parse(loginuser),
      id: this.props.match.params.id
    }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {

      });
  }
  reassignupdatetime() {
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      reassign_time: currenttime,
      reassign_date: currentdate,
      reassign_by: JSON.parse(loginuser),
      id: this.props.match.params.id,
      reason: "Reassign",
      created_by: JSON.parse(loginuser),
      color: "#edada0"
    }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {

      });
  }

  handleDeviationReasonChange = (e) => {
    const { value } = e.target;
    this.setState({ deviationReason: value });
  }

  closeDeviationModal = () => {
    this.setState({ deviationReason: "", deviationRequestFile: {} });
  }

  submitRequeryDeviation = () => {
    const { deviationRequestFile, deviationReason }: any = this.state;
    const loginuser: any = localStorage.getItem("user1");
    const obj = {
      deviationRequest_by: JSON.parse(loginuser),
      deviationRequest_file: deviationRequestFile.id,
      deviation_reason: "Kindly validate the Querie."
    }
    // if (deviationReason != "") {
    callApi("POST", "manager_deviation_request.php", obj)
      .then(res => res.data)
      .then(response => {
        if (response.success == true) {
          $("#deviation-Modal").modal("hide");
          this.setState({ deviationReason: "" });
          ToastsStore.success(response.message);
        } else {
          ToastsStore.error(response.message);
        }
      });
    // } else {
    //   ToastsStore.error("Please type reason to proceed");
    // }
  }

  deviationRequest = (file) => {
    if (file.deviation_status != 1) {
      $("#deviation-Modal").modal("show");
    } else {
      ToastsStore.error("This file is already in deviation queue.");
    }
    this.setState({ deviationRequestFile: file })
  }

  initiateDVerify = (id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Do you want to initiate double verification for this file?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        callApi("POST", "initiate_double_verification.php", { file_id: id })
          .then(res => res.data)
          .then(response => {
            if (response.success == true) {
              ToastsStore.success(response.message);
              this.getFiles();
            } else {
              ToastsStore.error(response.message);
            }
          }).catch(err => {
            console.log(err);
            ToastsStore.error("Something went wrong. Please try again later.");
          }
          );
      },
    });
  }

  getDeviationDropdownLists = () => {
    const categoryList = [
      "deviationRequestedBy",
      "deviationRequestReason",
      "designation",
      "doubtLocation",
    ];

    categoryList.forEach((cat) => {
      callApi("POST", "deviation_take_get.php", { category_type: cat })
        .then((res) => res.data)
        .then((response) => {
          if (response?.data) {
            const formattedData = response.data.map((item) => ({
              label: item.category_value,
              value: item.id,
            }));

            // ✅ Append “Other” option
            formattedData.push({ label: "Other", value: "other" });

            if (cat === "deviationRequestedBy") {
              this.setState({ deviationRequestByList: formattedData });
            } else if (cat === "deviationRequestReason") {
              this.setState({ deviationReasonList: formattedData });
            } else if (cat === "doubtLocation") {
              this.setState({ doubtLocationList: formattedData });
            }
          }
        })
        .catch((err) => console.error(err));
    });
  };

  getUsers = () => {
    callApi("GET", "user_get.php")
      .then((res) => res.data)
      .then((response) => {
        const usersoptions = response.data.map((u: any) => ({
          label: u.name,
          value: u.id,
          mob_no: u.mob_no,
          designation: u.roleType,
        }));
        usersoptions.push({ label: "Other", value: "other" });
        this.setState({ usersList: usersoptions });
      })
      .catch(console.log);
  };

  getDesignation = () => {
    callApi("GET", "get_role.php")
      .then((res) => res.data)
      .then((response) => {
        const designationOptions = response.data.map((u: any) => ({
          label: u.name,
          value: u.role_id,
        }));
        designationOptions.push({ label: "Other", value: "other" });
        this.setState({ designationList: designationOptions });
      })
      .catch(console.log);
  };

  handleDeviationChange = (value, key, type = "text") => {
    const { usersList } = this.state;
    this.setState((prevState: any) => {
      const deviationTakeDetails = { ...prevState.deviationTakeDetails };
      const showOtherFields = { ...deviationTakeDetails.showOtherFields };

      if (type === "singleselect") {
        if (value === "other") {
          showOtherFields[key] = true;
          deviationTakeDetails[key] = "";
        } else {
          showOtherFields[key] = false;
          deviationTakeDetails[key] = value;
        }
        if (key == 'deviationUser') {
          const userDetails: any = usersList?.find(
            (user: any) => String(user.value) === String(value)
          );
          deviationTakeDetails.mobileNo = userDetails?.mob_no || "";
          deviationTakeDetails.designation = userDetails?.designation || "";
        }
      }
      // else if (type === "multiselect") {
      //   // Multi-select dropdown — store an array of values
      //   const values = value.map((v) => v.value);
      //   deviationTakeDetails[key] = values;
      // } 
      else if (type === "multiselect") {
        const selectedValues = value.map((v) => v.value);

        // Check if "other" is selected
        if (selectedValues.includes("other")) {
          showOtherFields[key] = true;

          // Remove "other" from the list to avoid saving it as actual value
          deviationTakeDetails[key] = "";
        } else {
          showOtherFields[key] = false;
          deviationTakeDetails[key] = selectedValues;
        }
      }
      else {
        deviationTakeDetails[key] = value;
      }

      deviationTakeDetails.showOtherFields = showOtherFields;
      return { deviationTakeDetails };
    });
  };

  /** 🔹 Handle Submit */
  deviationTakenSubmit = () => {
    const { deviationUser, deviationRequestBy, doubtLocation, deviationRequestReason, designation, mobileNo } = this.state.deviationTakeDetails;
    const loginuser: any = localStorage.getItem("user1");

    if (isEmpty(deviationUser) || isEmpty(deviationRequestBy) || isEmpty(doubtLocation) || isEmpty(deviationRequestReason) || isEmpty(designation) || isEmpty(mobileNo)) {
      this.setState((prevState: any) => {
        const updatedDetails = { ...prevState.deviationTakeDetails };
        updatedDetails.deviationRequired = true;
        return { deviationTakeDetails: updatedDetails };
      });
      ToastsStore.error("Required fields are missing.");
      return;
    }
    this.setState({ isDeviationTakeLoading: true });
    const payload = { ...this.state.deviationTakeDetails, fileId: this.state.selectedFileId, userId: JSON.parse(loginuser), };
    callApi("POST", "deviation_taken_insert.php", payload)
      .then(res => res.data)
      .then(response => {
        if (response.success == true) {
          ToastsStore.success(response.message);
          $("#deviationTake").modal("hide");
          // ✅ Reset all fields after successful submit
          this.setState({ isDeviationTakeLoading: false });
          this.clearDeviationSummaryState();
          this.goToFileDashboard(this.state.selectedFileId, '')
        } else {
          ToastsStore.error(response.message);
        }
      }).catch(err => {
        console.log(err);
        this.setState({ files: [], isDeviationSummaryLoading: false });
      });
  };

  clearDeviationSummaryState = () => {
    this.setState({
      deviationTakeDetails: {
        deviationRequestBy: "",
        deviationUser: "",
        designation: "",
        deviationRequestReason: [],
        doubtLocation: [],
        mobileNo: "",
        deviationRequired: false,
        showOtherFields: {},
      },
    });
  }

  // renderSelectOrInput(label, key, options, required = true) {
  //   const { deviationTakeDetails } = this.state;

  //   return (
  //     <div className="form-group">
  //       <label>
  //         {label} {required && <span style={{ color: "red" }}>*</span>}
  //       </label>

  //       <Select
  //         options={options}
  //         className={
  //           deviationTakeDetails?.deviationRequired && deviationTakeDetails[key] === ""
  //             ? "form-select is-invalid"
  //             : "form-select"
  //         }
  //         value={options.find((o) => o.value === deviationTakeDetails[key]) || null}
  //         onChange={(e) => this.handleDeviationChange(e.value, key, "singleselect")}
  //       />

  //       {/* ✅ Show input when “Other” is selected */}
  //       {deviationTakeDetails?.showOtherFields[key] && (
  //         <input
  //           className={
  //             deviationTakeDetails?.deviationRequired && deviationTakeDetails[key] === ""
  //               ? "form-control is-invalid"
  //               : "form-control"
  //           }
  //           placeholder={`Enter Other ${label}...`}
  //           value={deviationTakeDetails[key] || ""}
  //           onChange={(e) => this.handleDeviationChange(e.target.value, key)}
  //         />
  //       )}
  //       <div className="invalid-feedback">*Required Field</div>
  //     </div>
  //   );
  // }

  renderSelectOrInput(label, key, options, type = "singleselect", required = true) {
    const { deviationTakeDetails } = this.state;

    const value =
      type === "multiselect"
        ? options.filter((o) => {
          if (o.value === "other") return deviationTakeDetails.showOtherFields[key];
          return deviationTakeDetails[key]?.includes(o.value);
        })
        : options.find((o) => o.value === deviationTakeDetails[key]) || null;

    return (
      <div className="form-group">
        <label>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>

        <Select
          options={options}
          isMulti={type === "multiselect"}
          className={
            deviationTakeDetails?.deviationRequired &&
              (deviationTakeDetails[key] === "" ||
                (Array.isArray(deviationTakeDetails[key]) &&
                  deviationTakeDetails[key].length === 0))
              ? "form-select is-invalid"
              : "form-select"
          }
          value={value}
          onChange={(selected) => {
            if (type === "multiselect") {
              this.handleDeviationChange(selected || [], key, "multiselect");
            } else {
              this.handleDeviationChange(selected?.value || "", key, "singleselect");
            }
          }}
        />

        {deviationTakeDetails?.showOtherFields[key] && (
          <input
            className={
              deviationTakeDetails?.deviationRequired && deviationTakeDetails[key] === ""
                ? "form-control is-invalid"
                : "form-control"
            }
            placeholder={`Enter Other ${label}...`}
            value={deviationTakeDetails[key] || ""}
            onChange={(e) => this.handleDeviationChange(e.target.value, key)}
          />
        )}
        <div className="invalid-feedback">*Required Field</div>
      </div>
    );
  }

  render() {
    const { status: vettingStatus, deviationRequestByList, deviationReasonList, doubtLocationList, designationList, usersList, isDeviationTakeLoading, isSearching }: any = this.state;
    const columns = [
      {
        header: 'ID',
        key: 'index',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.index}</td>
      },
      {
        header: 'Borrower Name',
        key: 'borrower_name',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.borrower_name}</td>
      },
      {
        header: 'Property Owner Name',
        key: 'property_ownername',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.property_ownername}</td>
      },
      {
        header: 'File Name',
        key: 'file_id',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.file_id}</td>
      },
      ...(this.props.match.params.name == "vetting" ? [
        {
          header: 'Existing File Name',
          key: 'existingFileNo',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.existingFileNo}</td>
        },
      ] : []),
      {
        header: 'Status',
        key: 'file_status',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }><div>{this.props.match.params.name != "vetting" ? getFileStatus(file.file_status) : getVettingFileStatus(file.file_status)}</div></td>
      },
      ...(this.props.match.params.name != "vetting" ? [
        {
          header: 'Rectification Status',
          key: 'rectify_status',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }><div>{file.rectify_status}</div></td>
        },
      ] : []),
      {
        header: 'Bank Name',
        key: 'bank_name',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.bank_name}</td>
      },
      ...(this.props.match.params.name != "vetting" ? [
        {
          header: 'Process Officer',
          key: 'assigned_to',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.assigned_to}</td>
        },
        {
          header: 'Q.V Officer',
          key: 'query_validation_officer_name',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.query_validation_officer_name}</td>
        },
        {
          header: 'Verified Officer',
          key: 'verified_by',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.verified_by}</td>
        }
      ] : [
        {
          header: 'Vetting Officer',
          key: 'assigned_to',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.assigned_to}</td>
        },
      ]),
      {
        header: 'Fronent Officer',
        key: 'login_by',
        td: (file) => <td onClick={() =>
          this.goToFileDashboard(file.id, file.process_office_id)
        }>{file.login_by}</td>
      },
      ...(this.props.match.params.name != "vetting" ? [
        {
          header: 'Rectification officer',
          key: 'rectification',
          td: (file) => <td onClick={() =>
            this.goToFileDashboard(file.id, file.process_office_id)
          }>{file.rectify_by}</td>
        },
      ] : []),
      ...(this.props.match.params.name == "vetting" ? [
        {
          header: "Actions",
          td: (file) => {
            return <div className="btn-group mb-2 mr-2">
              <button
                type="button"
                className="btn btn-primary"
              >
                Action
              </button>
              <button
                type="button"
                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="sr-only">
                  Toggle Dropdown
                </span>
              </button>
              <div
                className="dropdown-menu"
                x-placement="top-start"
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  transform:
                    "translate3d(88px, -2px, 0px)",
                  height: "auto",
                  overflowY: "auto",
                  maxHeight: "200px"
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => this.editVettingDetails(file)}
                  style={{
                    border: "none",
                    display: "block",
                    margin: "auto",
                  }}
                >
                  Vetting Details Edit
                </a>
              </div>
            </div>
          }
        }
      ] : []),
      ...(this.props.match.params.name != "vetting" ? [
        {
          header: "Actions",
          td: (file) => {
            return <div className="btn-group mb-2 mr-2">
              <button
                type="button"
                className="btn btn-primary"
              >
                Action
              </button>
              <button
                type="button"
                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="sr-only">
                  Toggle Dropdown
                </span>
              </button>
              <div
                className="dropdown-menu"
                x-placement="top-start"
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  transform:
                    "translate3d(88px, -2px, 0px)",
                  height: "auto",
                  overflowY: "auto",
                  maxHeight: "200px"
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => this.GotoWorkFile(file.id, file.process_office_id)}
                  style={{
                    border: "none",
                    // background: "none",
                    display: "block",
                    margin: "auto",
                  }}
                >
                  Work File
                </a>
                {this.state.pageDynamic.map((page: any, index: any) => {
                  if (page.page_name === "Reassign Button" && page.status == true) {
                    return (
                      <>
                        {/* {['0', '1', '2'].includes(roleType) && <> */}
                        <a
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target="#re-assign"
                          onClick={() => this.setFileId(file.id)}
                          style={{
                            border: "none",
                            // background: "none",
                            display: "block",
                            margin: "auto",
                          }}
                        >
                          Reassign
                        </a>
                        {/* </> } */}
                      </>
                    );
                  } else if (page.page_name === "Hold Button" && page.status == true) {
                    return (
                      <>
                        {(file.file_status != "5" && file.file_status != "11") && <>
                          <a
                            className="dropdown-item"
                            data-toggle="modal"
                            data-target="#unholdModal"
                            onClick={() => this.setFileId(file.id)}
                            style={{
                              border: "none",
                              // background: "none",
                              display: "block",
                              margin: "auto",
                            }}
                          >
                            Unhold
                          </a>
                        </>}
                        {(file.file_status != "5" && file.file_status != "11") &&
                          <>
                            <a
                              className="dropdown-item"
                              data-toggle="modal"
                              data-target="#holdModal"
                              onClick={() => this.setFileId(file.id)}
                              style={{
                                border: "none",
                                // background: "none",
                                display: "block",
                                margin: "auto",
                              }}
                            >
                              Hold
                            </a>
                          </>}
                      </>
                    );
                  } else if (page.page_name === "Deviation Request Button" && page.status == true) {
                    return (
                      <>
                        {/* {['0', '1', '2'].includes(roleType) && !["5", "6"].includes(file.file_status) && <> */}
                        <a
                          className="dropdown-item"
                          onClick={() => this.deviationRequest(file)}
                          style={{
                            border: "none",
                            // background: "none",
                            display: "block",
                            margin: "auto",
                          }}
                        >
                          Deviation Request
                        </a>
                        {/* </>} */}
                      </>
                    );
                  }
                  else if (page.page_name === "Initiate Double Verification" && page.status == true) {
                    return (
                      <>
                        <a
                          className="dropdown-item"
                          onClick={() => this.initiateDVerify(file.id)}
                          style={{
                            border: "none",
                            display: "block",
                            margin: "auto",
                          }}
                        >
                          Initiate Double Verification
                        </a>
                      </>
                    );
                  }
                  return null;
                })
                }
                <a
                  className="dropdown-item"
                  onClick={() => this.goToFileDashboard(file.id, file.process_office_id)}
                  style={{
                    border: "none",
                    // background: "none",
                    display: "block",
                    margin: "auto",
                  }}
                >
                  Dashboard
                </a>
                <a
                  className="dropdown-item"
                  data-toggle="modal"
                  data-target="#deviationTake"
                  onClick={() => this.setFileId(file.id)}
                  style={{
                    border: "none",
                    display: "block",
                    margin: "auto",
                  }}
                >
                  Deviation Take
                </a>
                {/* <a
                  className="dropdown-item"
                  style={{ float: "right" }}
                  data-toggle="modal"
                  data-target="#delete-bank"
                  onClick={() => this.getBillVettingComplete(file)}
                >
                  Vetting Completed
                </a> */}

                {/* {file.file_status === '6' &&
                <a
                  className="dropdown-item"
                  onClick={() =>
                    this.assignFile(file)
                  }
                  data-toggle="modal"
                  data-target="#verify-modal"
                  data-whatever="@mdo"
                >
                  Verify
                </a>
              } */}
              </div>
            </div>
          }
        }
      ] : []),
    ];
    const data = this.state.files;
    const { selectVal } = this.state;
    return (
      <section className="pcoded-main-container">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />{" "}
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>Search Results</h5>
                          <button
                            className="btn btn-primary"
                            style={{ float: "right" }}
                            onClick={() => {
                              this.props.history.push("/dashboard");
                            }}
                          >
                            Back
                          </button>
                        </div>
                        <div className="card-body">
                          {isSearching && (
                            <div className="text-center py-5">
                              <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                              <h5 className="mt-3">Searching for files...</h5>
                            </div>
                          )}

                          {!isSearching && this.state.isFileRefresh &&
                            <>
                              <ReactFlexyTable data={data} columns={columns} sortable globalSearch className='Flexy-table' />

                              {data && data.length == 0 && (
                                <div className="text-center text-muted py-4">
                                  <h6 className="mb-0">File recovery from backup is required. Please reach out to the Software Team for assistance.</h6>
                                </div>
                              )}
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <VerifyFileModal
          fileToBeVerified={this.state.fileToBeVerified}
          getFiles={this.getFiles}
          assignedFrom={"unassign"}
        /><div
          className="modal fade"
          id="delete-bank"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ textAlign: "center" }}>Vetting Completed</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {vettingStatus && (<h6>Your vetting report is completed please contact our support team</h6>)}

                {!vettingStatus && (
                  <>
                    <h6>If you want to complete the vetting report ?</h6>
                    <div className="form-group"></div>
                  </>
                )}
              </div>
              {!vettingStatus && (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={() => this.updateBillVettingComplete(1)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-dismiss="modal"
                    onClick={() => this.updateBillVettingComplete(0)}
                  >
                    No
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deviation-Modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="deviationLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>
                  Are you sure you want to request for deviation?
                </h5>
              </div>
              {/* <div
                className="modal-body"
              >
                <p style={{ textAlign: 'center', color: 'black' }}>Please Type a Reason To deviation request for this query</p>
                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                  <textarea
                    className="form-control"
                    placeholder="Type Your Reason"
                    onChange={(e) => this.handleDeviationReasonChange(e)}
                    value={this.state.deviationReason}
                    name="deviationReason" />
                  {(isEmpty(this.state.deviationReason)) ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please type your reason </p> : null}
                </div>
              </div> */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => this.closeDeviationModal()}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.submitRequeryDeviation()}
                >
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* THIS FOR OUT REASON MODAL */}
        {/* THIS FOR OUT REASON MODAL */}
        <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog ">
            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
              </div>
              <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                <select
                  className="custom-select"
                  name="outreason"
                  value={this.state.outreason}
                  onChange={(e) => this.onchangeReason(e)}
                  required
                  id="select1"
                  style={{ marginTop: '8px' }}
                >
                  <option value="select">Select Your Reason</option>
                  <option value="Query Raised">Query Raised</option>
                  <option value=" Re-Query Raised"> Re-Query Raised</option>
                  <option value="Hold ">Hold </option>
                  <option value="Completed">Completed</option>
                  <option value="Other">Others</option>

                </select>
                {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
              </div>
              <div className="modal-footer" style={{ marginTop: '27px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={this.state.isLoading}
                  onClick={this.outimeGet}
                  style={{ width: '76px', fontSize: '17px' }}
                > {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : "OK"}</button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={this.BacktoFile}
                  style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                > Back To File</button>
              </div>
            </div>
          </div>
        </div>
        {/* OTHER REASON MODAL */}
        <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog ">
            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
              <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                {/* <div className="col-md-5"> */}
                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                  <textarea
                    className="form-control"
                    placeholder="Type Your Reason"
                    name="outreason" onChange={this.onchange} />
                  {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                </div>
                {/* </div> */}

              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.outimeGet()}
                  style={{ width: '76px', fontSize: '17px' }}
                  disabled={this.state.isLoading}
                > {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : "OK"}</button>
                <button
                  type="button"
                  className="btn btn-outline"

                  onClick={() => this.previousPop()}
                  style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                > Back</button>
              </div>
            </div>
          </div>
        </div>
        {/* {THIS FOR ASSIGN MODAL} */}
        <div className="modal assign-modal  hide in" id="re-assign" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog ">
            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
              <div className="modal-header">
                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select Reassign Type for The File.No:{this.state.selectedFileId}</h3>
              </div>
              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                <div style={{ color: 'black', marginLeft: '12%' }}>
                  <p>Note:</p>
                  <ul>
                    <li>File is in New File, Queue, Query Raised, Hold or Completed can't be Reassign the file.</li>
                  </ul>
                </div>
                <div className="form-group" style={{ width: '74%', margin: 'auto', marginTop: "10%" }}>
                  <select
                    className="custom-select"
                    name="reassign_type"
                    value={this.state.reassign_type}
                    onChange={(e) => this.onchangeReason(e)}
                    required
                    id="select1"
                    style={{ marginTop: '8px' }}
                  >
                    <option value="select">Select Your Type</option>
                    <option value="process">Process</option>
                    <option value="verification">Verification</option>
                  </select>
                  {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Type </p> : null}
                  {this.state.showValid && <p style={{ color: "red", fontSize: "14px" }}>{this.state.reassignValidMessage}</p>}
                </div>
              </div>
              <div className="modal-footer" style={{ marginTop: '27px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={this.state.isLoading}
                  onClick={() => { this.fileReassign() }}
                  style={{ fontSize: '17px' }}
                > {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : "Reassign"}</button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => { this.disableReassignModalHandler() }}
                  data-bs-dismiss="re-assign" aria-label="Close"
                  style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                > Cancel</button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="deviationTake"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="deviationTakeLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Deviation Take</h5>
              </div>
              <div className="modal-body">
                {this.renderSelectOrInput("Deviation Requested By", "deviationRequestBy", deviationRequestByList)}
                {this.renderSelectOrInput("Name", "deviationUser", usersList)}
                <div className="form-group">
                  <label>
                    Mobile No<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className={
                      this.state.deviationTakeDetails.deviationRequired &&
                        this.state.deviationTakeDetails.mobileNo === ""
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    placeholder="Mobile No..."
                    name="mobileNo"
                    value={this.state.deviationTakeDetails.mobileNo || ""}
                    onChange={(e) => this.handleDeviationChange(e.target.value, "mobileNo")}
                  />
                  <div className="invalid-feedback">*Required Field</div>
                </div>
                {this.renderSelectOrInput("Designation", "designation", designationList)}
                {this.renderSelectOrInput("Deviation Request Reason", "deviationRequestReason", deviationReasonList, "multiselect")}
                {this.renderSelectOrInput("Doubt Location", "doubtLocation", doubtLocationList, "multiselect")}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => this.clearDeviationSummaryState()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.deviationTakenSubmit}
                >
                  {isDeviationTakeLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="unholdModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="holdModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>
                  Are you sure you want to unhold {this.state.selectedFileId}?
                </h5>
              </div>
              {this.state.unholdVal && <>
                <div
                  className="modal-body"
                >
                  <p style={{ textAlign: 'center', color: 'black' }}>Please Type a Reason To Unhold The File</p>
                  <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                    <textarea
                      className="form-control"
                      placeholder="Type Your Reason"
                      name="unholdreason" onChange={this.onchange} />
                    {(isEmpty(this.state.unholdreason)) ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please type your reason </p> : null}
                  </div>
                </div>
              </>}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.unholdFile()}
                >
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="holdModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="holdModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>
                  Are you sure you want to hold {this.state.selectedFileId}?
                </h5>
              </div>
              {this.state.holdVal && <>
                <div
                  className="modal-body"
                >
                  <p style={{ textAlign: 'center', color: 'black' }}>Please Type a Reason To hold The File</p>
                  <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                    <textarea
                      className="form-control"
                      placeholder="Type Your Reason"
                      name="holdreason" onChange={this.onchange} />
                    {(isEmpty(this.state.holdreason)) ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please type your reason </p> : null}
                  </div>
                </div>
              </>}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.holdFile()}
                >
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}